export const MappingType = Object.freeze({
  FIELD: 'Field',
  HARDCODE: 'Hardcode',
  FORMULA: 'Formula',
  TRANSFORM: 'Transform',
});

export const GLOBAL_ADMIN_PERMISSION = 'admin:global';
